import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M21 3H7.5C7.10254 3.00119 6.7217 3.1596 6.44065 3.44065C6.1596 3.7217 6.00119 4.10254 6 4.5V15C6.00119 15.3975 6.1596 15.7783 6.44065 16.0593C6.7217 16.3404 7.10254 16.4988 7.5 16.5H21C21.3975 16.4988 21.7783 16.3404 22.0593 16.0593C22.3404 15.7783 22.4988 15.3975 22.5 15V4.5C22.4988 4.10254 22.3404 3.7217 22.0593 3.44065C21.7783 3.1596 21.3975 3.00119 21 3V3ZM21 15H7.5V4.5H21V15Z',
                    fill: '#777777',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M13.5 19.5H3V12H4.5V10.5H3C2.60254 10.5012 2.2217 10.6596 1.94065 10.9407C1.6596 11.2217 1.50119 11.6025 1.5 12V19.5C1.50119 19.8975 1.6596 20.2783 1.94065 20.5593C2.2217 20.8404 2.60254 20.9988 3 21H13.5C13.8975 20.9988 14.2783 20.8404 14.5593 20.5593C14.8404 20.2783 14.9988 19.8975 15 19.5V18H13.5V19.5Z',
                    fill: '#777777',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const PopupOutlined = React.forwardRef(IconComponent);
PopupOutlined.displayName = 'PopupOutlined';

export { PopupOutlined };
